import React from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import TabbedView from "../../App/Components/TabbedView/TabbedView";
import ManageLocationsPage from "./Components/Tabs/ManageLocations/ManageLocationsPage";
import UploadLocationsPage from "./Components/Tabs/UploadLocations/UploadLocationsPage";

function LocationsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);

  const tabs = [
    { title: "Manage", component: <ManageLocationsPage /> },
    { title: "Upload", component: <UploadLocationsPage /> },
  ];

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Locations
        </h1>
        <div className={classes.root}>
          <TabbedView tabs={tabs} />
        </div>
      </div>
    </>
  );
}

export default LocationsPage;
